<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('change_phone') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form class="px-2">
            <!-- <ValidationProvider v-slot="{ errors, valid }" name="current_phone" rules="required|phoneNumber">
              <v-text-field v-model="form.old_phone" type="text" label="Current Phone" color="primary" :error-messages="errors" />
            </ValidationProvider> -->
            <l-a-phone-number v-model="form.old_phone" name-validation="current_phone" :label="$t('fields.current_phone')" />
            <!-- <ValidationProvider v-slot="{ errors, valid }" name="phone" rules="required|phoneNumber">
              <v-text-field v-model="form.new_phone" type="text" label="New Phone" color="primary" :error-messages="errors" />
            </ValidationProvider> -->
            <l-a-phone-number v-model="form.new_phone" :label="$t('fields.phone')" />
            <ValidationProvider v-slot="{ errors, valid }" name="password" rules="min:8">
              <v-text-field v-model="form.password" outlined dense :type="visibility ? 'text' : 'password'" label="Password" color="primary" :error-messages="errors" :append-icon="visibility ? 'mdi-eye' : 'mdi-eye-off'" autocomplete="on" @click:append="visibility = !visibility" />
            </ValidationProvider>
            <v-btn color="primary" x-large block class="text-none" @click="changePhone">
              {{ $t('save') }}
            </v-btn>
          </v-form>
        </ValidationObserver>
        <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
          {{ dataSuccess.message }}
          <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  changePhone as changePhoneCustomer
} from '@/api/customer'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
export default {
  components: {
    LAPhoneNumber,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      dataSuccess: {
        show: false,
        message: ''
      },
      visibility: false,
      form: {
        old_phone: '',
        new_phone: '',
        password: '',
        otp_type: 2
      },
      data_verification: {}
    }
  },
  mounted() {
    const dataProfile = {
      show: false,
      user: {}
    }
    this.$root.$emit('ShowProfile', dataProfile)
    const closeMenu = {
      show: false,
      permanent: false
    }
    this.$root.$emit('ShowMenu', closeMenu)
  },
  methods: {
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    async changePhone() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          const { data } = await changePhoneCustomer(this.form)
          this.data_verification.data = data.data
          this.$store.state.loading_axios = false
          this.dataSuccess.show = true
          this.dataSuccess.message = data.message
          const dataUser = data.data
          dataUser['new_phone'] = this.form.new_phone
          dataUser['password'] = this.form.password
          this.$store.dispatch('data_verification_without_save', dataUser)
          this.$store.dispatch('save_type_verification', 'sms')
          this.$store.dispatch('data_verification', this.data_verification)
          setTimeout(() => this.$router.push({ name: 'chenge_phone_verification' }).catch(() => {}), 2000)
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    }
  }
}
</script>
